import React from "react";
import { Container, Display, Filter, Head, Menu } from "./styles";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import { CiCalendar } from "react-icons/ci";
import { useReports } from "@hooks/report";

export default function Mensal() {
  const {
    mensal: data,
    ano,
    setAno,
    mes,
    setMes,
    fetchData,
    handleMonthChange,
  } = useReports();

  return (
    <Container>
      <Head>
        <div className="calendar">
          <div className="btn" onClick={() => handleMonthChange("down")}>
            <MdOutlineKeyboardArrowDown />
          </div>
          <div className="btn" onClick={() => handleMonthChange("up")}>
            <MdOutlineKeyboardArrowUp />
          </div>
          <div className="date">
            <p>
              {new Date(ano, mes)
                .toLocaleString("default", { month: "long", year: "numeric" })
                .toUpperCase()}
            </p>
          </div>
        </div>
        {data && (
          <div className="infos">
            <div className="info">
              <div className="tag">
                <p>Total</p>
              </div>
              <div className="content">
                <p>{data.monthlyTotal}</p>
              </div>
            </div>
            <div className="info">
              <div className="tag">
                <p>Baixadas</p>
              </div>
              <div className="content">
                <p>{data.monthlyBaixadas}</p>
              </div>
            </div>
            <div className="info">
              <div className="tag">
                <p>Faltantes</p>
              </div>
              <div className="content">
                <p>{data.monthlyFaltantes}</p>
              </div>
            </div>
            <div className="info">
              <div className="tag">
                <p>Canceladas</p>
              </div>
              <div className="content">
                <p>{data.monthlyCanceladas}</p>
              </div>
            </div>
          </div>
        )}
      </Head>
      <Filter>
        <div className="item data">
          <CiCalendar />
          <p>Data</p>
        </div>
        <div className="item data">
          <CiCalendar />
          <p>Total</p>
        </div>
        <div className="item data">
          <CiCalendar />
          <p>Baixadas</p>
        </div>
        <div className="item data">
          <CiCalendar />
          <p>Faltantes</p>
        </div>
        <div className="item data">
          <CiCalendar />
          <p>Canceladas</p>
        </div>
      </Filter>
      <Display>
        {data &&
          Object.keys(data.reportsByDay).map((day) => (
            <React.Fragment key={day}>
              <div className="items">
                <div className="item ">
                  <p>{`${String(day).padStart(2, "0")}/${String(
                    mes + 1
                  ).padStart(2, "0")}/${ano}`}</p>
                </div>
                <div className="item">
                  <p>{data.reportsByDay[day].total}</p>
                </div>
                <div className="item">
                  <p>{data.reportsByDay[day].baixadas}</p>
                </div>
                <div className="item">
                  <p>{data.reportsByDay[day].faltantes}</p>
                </div>
                <div className="item">
                  <p>{data.reportsByDay[day].canceladas}</p>
                </div>
              </div>
            </React.Fragment>
          ))}
      </Display>
    </Container>
  );
}
